
export enum USER_ROLES {
  USER = 'USER',
  ADMIN = 'ADMIN'
}

export type TParsedTokenId = {
  "sub": string,
  "aud": string,
  "jti": string,
  "iss": string,
  "iat": number,
  "exp": number,
  "auth_time": number,
  "role": USER_ROLES,
  "familyName": string,
  "givenName": string,
  "uuid": string,
  "email": string,
  "username": string,
  "pi.sri": string,
  "s_hash": string
}

export enum UserType {
  THIRD_PARTY_DEV = 'THIRD_PARTY_DEV',
  GW_DEV = 'GW_DEV',
  GW_ADMIN = 'GW_ADMIN',
  GW_SUPPORT = 'GW_SUPPORT',
  EHR_USER = 'EHR_USER',
  PATIENT = 'PATIENT',
  UNASSIGNED = 'UNASSIGNED'
}